import { render, staticRenderFns } from "./NotificationDropDownList.vue?vue&type=template&id=5501ef7c&"
import script from "./NotificationDropDownList.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports